<template>
<div class="contrast">
  <div class="contrast-title" v-if="cItem.hide_title == 0">
    <img :src="static_img_url + 'pic/module_tct_icon.png'" />{{cItem.title}}
  </div>
  <div class="contrast-summary" v-html="cItem.summary"></div>
  <div class="contrast-nav">
    <CheckboxGroup v-model="entity_list">
      <Checkbox :label="item.id" v-for="item, index in cItem.content.x" :key="index">
        <span>{{item.short_name}}</span>
      </Checkbox>
    </CheckboxGroup>
  </div>
  <div style="position: relative; overflow: hidden; margin-top: 10px;">
    <div class="contrast-left-nav">
      <div class="left-nav-top" v-if="cItem.time_show_type == 0">领域/年</div>
      <div class="left-nav-top" v-if="cItem.time_show_type == 1">领域/季度</div>
      <div class="left-nav-top" v-if="cItem.time_show_type == 2">领域/月</div>
      <div class="left-nav" >
        <div v-for="item in cItem.content.y" :key="item" :style="{'min-height': cItem.content.x.length * 9 - 2 + 'px'}">{{item | dealName(meta.entity_ntag)}}</div>
      </div>
    </div>
    <div class="contrast-bg">
      <div class="contrast-content">
        <div class="contrast-head">
          <div class="head-1" v-if="cItem.time_show_type == 0">领域/年</div>
          <div class="head-1" v-if="cItem.time_show_type == 1">领域/季度</div>
          <div class="head-1" v-if="cItem.time_show_type == 2">领域/月</div>
          <div class="head-2">
            <div
              class="head-item"
              v-for="year_item,year_index in years_axis"
              :key="year_index"
            >
              <span>{{year_item | tct_time_list(cItem.time_show_type)}}</span>
            </div>
          </div>
        </div>
        <div class="contrast-list">
          <div class="contrast-li" v-for="item in cItem.content.y" :key="item">
            <div class="label-tag">{{item | dealName(meta.entity_ntag)}}</div>
            <div class="label-data">
              <div
                class="year-item"
                v-for="year_item,year_index in years_axis"
                v-if="year_index < years_axis.length"
                :key="year_index"
              >
                <div>
                  <div
                    class="data-item"
                    v-for="item2,index2 in cItem.content.x"
                    :key="index2"
                  >
                    <Tooltip
                      :placement="tooltip_placement(year_index, years_axis.length)"
                      v-for="item3,index3 in cItem.content.res"
                      :key="index3"
                      v-if="item3.tag_id == item && item3.entity_id == item2.id && time_bollen(item3, year_item) && entity_list.findIndex((a) => a == item3.entity_id) > -1"
                    >
                      <span
                        :style="{'width': item_width(item3.ca_num), 'background-color': colors1[index2] || 'rgba(250, 122, 80, 1)'}"
                        @click="handleClickItem(item3)"
                      ></span>
                      <div slot="content" @click="handleClickItem(item3)">
                        <p class="p1">{{item | dealName(meta.entity_ntag)}}（共{{item3.ca_num}}起）</p>
                        <p class="p2">
                          <i :style="{'background-color': colors1[index2] || 'rgba(250, 122, 80, 1)'}"></i>{{item2.short_name}}
                        </p>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
  <div class="spa">
    <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
      <i class="iconfont">&#xe641;</i>
      <div slot="content" class="share_cnt clear">
        <div class="share_img"></div>
        <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
      </div>
    </Poptip>
  </div>
  <Modal
    v-model="detail_modal"
    class="detail-modal"
    width="320"
  >
    <div slot="header">{{modal_tag | dealName(meta.entity_ntag)}}(共{{event_list.length}}起)</div>
    <div class="list">
      <div v-for="e_item,e_index in event_list" :key="e_index">
        <i class="iconfont">&#xe6b9;</i>
        <div class="li-top">
          <span @click="goEntityDetail(e_item.comp_uid, e_item.type)">{{e_item.short_name}}</span>
        </div>
        <div class="li-bto">
          <span>{{e_item.event_time | time_moment}}</span>
          <span v-if="e_item.event_type == 0">{{e_item.round_id | dealName(meta.round)}}</span>
          <span v-if="e_item.event_type == 1">并购</span>
          <span>{{e_item.amount | amountPrecise(e_item.unit_id, e_item.precise, meta.unit)}}</span>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button @click="detail_modal = !detail_modal">知道了</Button>
    </div>
  </Modal>
</div>
</template>
<script>
import { tctEntityList } from '../../../service'
export default {
  props: ['cItem', 'paramsUid', 'meta'],
  data() {
    return {
      colors1: ['#9254DE', '#40A9FF', '#1EA69B', '#FFCB6A', '#E96350'],
      entity_list: [],
      event_list: [],
      detail_modal: false,
      modal_tag: '',
      max_num: 0,
      min_num: 0
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
    years_axis() {
      let arr = [],
          start_year = this.cItem.start_time ? moment(this.cItem.start_time).year() : 2010,
          end_year = this.cItem.end_time ? moment(this.cItem.end_time).year() : moment().year(),
          start_quarter = this.cItem.start_time ? moment(this.cItem.start_time).quarter() : 1,
          end_quarter = this.cItem.end_time ? moment(this.cItem.end_time).quarter() : moment().quarter(),
          start_month = this.cItem.start_time ? moment(this.cItem.start_time).month() + 1 : 1,
          end_month = this.cItem.end_time ? moment(this.cItem.end_time).month() + 1 : moment().month() + 1
      for (var i = start_year; i <= end_year; i++) {
        if (this.cItem.time_show_type == 0) {
          arr.push(i)
        } else if (this.cItem.time_show_type == 1){
          if (i == start_year && i != end_year) {
            for (var j = start_quarter; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_quarter; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else {
            for (var j = 1; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          }
        } else if (this.cItem.time_show_type == 2){
          if (i == start_year && i != end_year) {
            for (var j = start_month; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_month; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else {
            for (var j = 1; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          }
        }
      }
      return arr
    },
    time_bollen() {
      return function(item, t) {
        if (this.cItem.time_show_type == 0) {
          return item.year == t
        } else if (this.cItem.time_show_type == 1) {
          return item.year == t.split('Q')[0] && item.quarter == t.split('Q')[1]
        } else if (this.cItem.time_show_type == 2) {
          return item.year == t.split('.')[0] && item.month == t.split('.')[1]
        }
      }
    },
    item_width() {
      return function(n) {
        let l = this.max_num - this.min_num
        let m = n - this.min_num
        return m > 0 ? 10 + 20*(m/l) + 'px' : '10px'
      }
    },
    tooltip_placement() {
      return function(idx, len) {
        let p = 'top'
        if (idx == len - 1) {
          p = 'top-end'
        }
        if (idx == 0) {
          p = 'top-start'
        }
        return p
      }
    }
  },
  methods: {
    async handleClickItem(item) {
      this.modal_tag = item.tag_id
      let res = await tctEntityList({
        entity_ids: [item.entity_id],
        tag_ids: [item.tag_id],
        start_time: this.cItem.start_time,
        end_time:  this.cItem.end_time,
        year: item.year,
        quarter: item.quarter || '',
        month: item.month || ''
      }, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'event_list', res.res)
        this.detail_modal = true
      } else {
        this.$Message.error(res.message)
      }
    },
    handleShare(theme_uid) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareScatter?tct_id='+this.cItem.id+'&theme_uid=' + theme_uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    },
    goEntityDetail(uid, type) {
      if (type == 0) {
        const {
          href
        } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if (type == 1) {
        const {
          href
        } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if (type == 2) {
        const {
          href
        } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if (type == 3) {
        const {
          href
        } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    }
  },
  created() {
    this.cItem.content.x.map((a) => {
      this.entity_list.push(a.id)
    })
    this.max_num = this.min_num = this.cItem.content.res[0] ? Number(this.cItem.content.res[0].ca_num) : 0
    this.cItem.content.res.map((a) => {
      this.max_num = Number(a.ca_num) > this.max_num ? Number(a.ca_num) : this.max_num
      this.min_num = Number(a.ca_num) > this.min_num ? this.min_num : Number(a.ca_num)
    })
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/constrast.stylus'
.contrast .contrast-left-nav .left-nav-top
  height: 44px
  padding: 0 0 0 20px
.contrast .contrast-left-nav .left-nav > div
  padding: 16px 20px
  width: 60px
  box-sizing: content-box
  display: flex
  align-items: center;
.contrast
  &-nav >>> .ivu-checkbox-wrapper
    &:nth-of-type(1)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #9254DE
          background-color: #9254DE
    &:nth-of-type(2)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #40A9FF
          background-color: #40A9FF
    &:nth-of-type(3)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #1EA69B
          background-color: #1EA69B
    &:nth-of-type(4)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #FFCB6A
          background-color: #FFCB6A
    &:nth-of-type(5)
      .ivu-checkbox-checked
        .ivu-checkbox-inner
          border-color: #E96350
          background-color: #E96350
</style>
